import React, { useContext, useState } from 'react';
import { usePagination, useSortBy, useTable } from 'react-table';
import SortAscendingIcon from 'mdi-react/SortAscendingIcon';
import SortDescendingIcon from 'mdi-react/SortDescendingIcon';
import SortIcon from 'mdi-react/SortIcon';
import Constants from '../../Constants';
import "./DataTable.css"
import Loader from '../Loader';
import LockIcon from "mdi-react/LockIcon";
import ConfirmPopup from "../../Utils/ConfirmPopup";
import { UserContext } from '../../Contexts/UserContext';
const defaultPropGetter = () => ({})

/**
 * The DataTable function is a JavaScript function that renders a table with sortable columns,
 * pagination, and optional loader and empty data placeholders.
 * @returns The DataTable component is returning a JSX element.
 */

function AllDataTable({
    columns,
    data,
    disableSortBy,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
    sortBy = [],
    emptyDataPlaceholder,
    showLoader = false,
}) {
    const tableInstance = useTable(
        {
            columns,
            data,
            disableSortRemove: true,
            initialState: { sortBy: sortBy },
            disableSortBy,
        },
        useSortBy
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = tableInstance;

    const [alert, setalert] = useState({ message: "", show: false });

    const onConfirmation = () => {
        setalert({ show: false, message: "" });
    };

    const onBlurColumnClick = () => {
        setalert({
            show: true,
            message: Constants.subscribeProductMsg,
            isAlertOnly: true,
            closeBtnName: "OK",
        });
    };
    

    return (
        <>
            <div className={`overflow-x-auto scrollbar max-h-[70vh]`}>
                {rows?.length > 0 ? (
                    <table className="datatable w-full" {...getTableProps()}>
                        <thead className="text-[12pt] leading-[15pt] bg-[#EDEDED] lg:text-[13px] text-[#666666] font-bold sticky top-0 z-10">
                            {headerGroups.map(headerGroup => (
                                <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps([
                                                {
                                                    className: `py-3.5 px-5 whitespace-nowrap ${column.headerClassName}`,
                                                    style: column.headerStyle,
                                                },
                                                column.getSortByToggleProps(),
                                                getColumnProps(column),
                                                getHeaderProps(column),
                                            ])}
                                        >
                                            <div className="flex">
                                                <span className={`mr-1 ${column.headerspanClassName || ''}`}>
                                                    {column.render('Header')}
                                                </span>
                                                {disableSortBy === true ? "" : column.isSorted ? (
                                                    column.isSortedDesc ? (
                                                        <SortAscendingIcon size={16} className="mt-[0.15rem]" />
                                                    ) : (
                                                        <SortDescendingIcon size={16} className="mt-[0.15rem]" />
                                                    )
                                                ) : (
                                                    <SortIcon size={16} className="mt-[0.15rem]" />
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()} className="text-[12pt] lg:text-[14px] text-left">
                            {rows.map(row => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps(getRowProps(row))} className="border-b">
                                        {row.cells.map(cell => {
                                            if (cell.value === Constants.restrictedPlaceholder) {
                                                return (
                                                    <td
                                                        onClick={onBlurColumnClick}
                                                        className="relative whitespace-nowrap cursor-pointer"
                                                        {...cell.getCellProps()}
                                                    >
                                                        <div className="blur-sm bg-[#C9C9C9] flex justify-center select-none px-5 py-4">
                                                            {Constants.restrictedPlaceholder}
                                                        </div>
                                                        <div className="absolute inset-0 flex items-center justify-center">
                                                            <LockIcon size={16} />
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            return (
                                                <td
                                                    {...cell.getCellProps([
                                                        {
                                                            className: `data-td-animate lg:whitespace-nowrap px-5 py-4 ${cell.column.className || ''}`,
                                                            style: cell.column.style,
                                                        },
                                                        getColumnProps(cell.column),
                                                        getCellProps(cell),
                                                    ])}
                                                >
                                                    {cell.value ? cell.render('Cell') : " "}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                ) : ( !showLoader &&
                    <div className="h-[3rem] text-center mt-[1rem] text-[#333333] text-[15px]">
                        No data found
                    </div>
                )}
                {showLoader ? (
                    <div className="flex flex-col items-center justify-center h-40">
                        <Loader />
                    </div>
                ) : emptyDataPlaceholder && rows?.length <= 0 ? (
                    emptyDataPlaceholder
                ) : null}
            </div>
            <ConfirmPopup {...alert} onChange={onConfirmation} />
        </>
    );
}

export default AllDataTable;